/**
 * Site-wide: show first in-stock variant image on product cards and listings.
 */
(function () {
  'use strict';

  function variantHasImage(v) {
    if (!v || !v.featured_image) return false;
    return !!(v.featured_image.src || typeof v.featured_image === 'string');
  }

  function firstAvailableVariantWithImage(product) {
    var variants = (product && product.variants) || [];
    var i;
    for (i = 0; i < variants.length; i++) {
      if (variants[i].available && variantHasImage(variants[i])) return variants[i];
    }
    for (i = 0; i < variants.length; i++) {
      if (variants[i].available) return variants[i];
    }
    return variants[0] || null;
  }

  function resizeWidth(src, width) {
    if (!src || !width) return src || '';
    var base = String(src).split('?')[0];
    return base + '?width=' + width;
  }

  function variantImageSrc(variant, width) {
    if (!variant || !variant.featured_image) return '';
    var src =
      typeof variant.featured_image === 'string' ? variant.featured_image : variant.featured_image.src;
    return src ? resizeWidth(src, width) : '';
  }

  function productImageUrl(product, width) {
    width = width || 400;
    if (!product) return '';
    var v = firstAvailableVariantWithImage(product);
    var fromVariant = variantImageSrc(v, width);
    if (fromVariant) return fromVariant;
    if (typeof product.featured_image === 'string' && product.featured_image) {
      return resizeWidth(product.featured_image, width);
    }
    if (product.featured_image && product.featured_image.src) {
      return resizeWidth(product.featured_image.src, width);
    }
    if (product.images && product.images.length) {
      return resizeWidth(product.images[0], width);
    }
    return '';
  }

  function patchImgFromProduct(img, product) {
    if (!img || !product) return;
    var w = parseInt(img.getAttribute('width'), 10) || 400;
    var url = productImageUrl(product, w);
    if (!url) return;
    if (img.src !== url) {
      img.src = url;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
    }
    img.setAttribute('data-mm-avail-ready', '1');
  }

  var fetchCache = {};

  function apiRoot() {
    if (window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string') {
      var r = window.Shopify.routes.root;
      return r.slice(-1) === '/' ? r : r + '/';
    }
    return '/';
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (fetchCache[handle]) return fetchCache[handle];
    fetchCache[handle] = fetch(apiRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
    return fetchCache[handle];
  }

  function findHandle(el) {
    var node = el;
    while (node && node !== document.body) {
      if (node.getAttribute) {
        var h = node.getAttribute('data-handle') || node.getAttribute('data-product-handle');
        if (h) return h;
      }
      node = node.parentElement;
    }
    return '';
  }

  function refreshImg(img) {
    if (!img || img.getAttribute('data-mm-avail-ready') === '1') return;
    if (img.getAttribute('data-mm-avail-skip') === '1') return;
    var handle = img.getAttribute('data-product-handle') || findHandle(img);
    if (!handle) return;
    if (img.getAttribute('data-mm-avail-pending') === handle) return;
    img.setAttribute('data-mm-avail-pending', handle);
    fetchProduct(handle).then(function (product) {
      img.removeAttribute('data-mm-avail-pending');
      if (product) patchImgFromProduct(img, product);
    });
  }

  function refreshAll(root) {
    var scope = root || document;
    scope.querySelectorAll('img[data-mm-product-img]:not([data-mm-avail-ready])').forEach(refreshImg);
    scope.querySelectorAll('[data-handle] img[src*="cdn.shopify"]:not([data-mm-avail-ready])').forEach(function (img) {
      if (!img.hasAttribute('data-mm-product-img')) {
        img.setAttribute('data-mm-product-img', '');
        refreshImg(img);
      }
    });
  }

  var observer =
    typeof MutationObserver !== 'undefined'
      ? new MutationObserver(function (mutations) {
          mutations.forEach(function (m) {
            Array.prototype.forEach.call(m.addedNodes, function (node) {
              if (!node || node.nodeType !== 1) return;
              if (node.matches && node.matches('img[data-mm-product-img]')) refreshImg(node);
              if (node.querySelectorAll) refreshAll(node);
            });
          });
        })
      : null;

  function boot() {
    refreshAll();
    if (observer) observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.MMProductImage = {
    url: productImageUrl,
    patch: patchImgFromProduct,
    firstAvailableVariant: firstAvailableVariantWithImage,
    refreshAll: refreshAll,
    fetchProduct: fetchProduct,
  };
})();
